import { ReactComponent as FlagIcon } from "./svg/ro-flag.svg";
import "../flag-icon.scss";

export const ROFlag = () => {
  return (
    <span className="flag-icon">
      <FlagIcon />
    </span>
  );
};
